
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/library/projection",
      function () {
        return require("private-next-pages/en/ir/library/projection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/library/projection"])
      });
    }
  